import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(XHR)
    .use(LanguageDetector);

export default i18n;



// WEBPACK FOOTER //
// ./src/app-lib/i18n.js